// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","290":"component---src-pages-privacy-policy-mdx","809":"component---src-pages-index-mdx"}[chunkId] + "-" + {"218":"a2fee3095f7d10e0139a","290":"e036a10a60faf0d61cce","809":"acd1b7825fd4a4bc6ad3"}[chunkId] + ".js";
};